<template>
  <div class="kt-footer kt-grid__item mt-auto" style="background-color: #fff;">
    <div class="kt-container kt-container--fluid">
      <div class="kt-footer__wrapper">
        <div class="kt-footer__copyright">
          <div class="powered-by-text">Powered by<br><img class="logoFooter" src="/img/logo-transparent.png" width="85" height="27"></div>
          All rights reserved: ©Global Encounters™ 1999-2019
        </div>
        <div class="kt-footer__menu">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style lang="scss" scoped>
.kt-footer {
  background-color: #fff;
  padding: 0 0;
}
.kt-footer__copyright {
  display: flex;
  align-content: flex-end;
  justify-content: center;
  align-items: flex-end;
  font-size: 0.95rem!important;
}
.powered-by-text {
  font-size: 0.92rem;
  font-weight: 600;
  margin-right: 10px;
}
.FooterHome{
  position: absolute;
  bottom: 0;
}
.logoFooter{
    background-image: url(/img/logo-itp.png);
    background-size: contain;
    background-repeat: no-repeat;
    margin-top: 3px;
}
.FooterHome.kt-footer {
  background-color: transparent!important;
  .kt-footer__wrapper .kt-footer__copyright{
    color:#FFFFFF;
  }
}
.FooterHome .logoFooter{
    background-image: url(/img/logo-itp-white.png);
}
</style>
